import { render, staticRenderFns } from "./form_0600.vue?vue&type=template&id=5b976eb4"
import script from "./form_0600.vue?vue&type=script&lang=js"
export * from "./form_0600.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports